import React from 'react'
import {Col} from 'reactstrap'
import Error from './elements/Error'
import LabelWithInfo from './elements/LabelWithInfo'

function RadioVal(props) {

    const {name, info, data, field, stuff, disabled, error} = props;
    let value = data && field && data[field];

    // invalid default value
    if (stuff && value && !stuff.find(x => x.value === value)) {
        console.warn(`Unknown radio value ${value} for ${field}`);
        value = null;
    }

    const onChange = (value) => {
        props.onChange(data, field, value);
    };

    const radioButtons = stuff && stuff.map((e, i) => (
        <div key={i}>
            <input type="radio" name={name} value={e.value} checked={value === e.value} disabled={disabled}
                   onChange={() => onChange(e.value)} />
            <label className="form-check-label ms-2" onClick={() => !disabled && onChange(e.value)}>{e.name}</label>
        </div>
    ));

    return (
        <div className="form-group row g-0">
            <Col sm="12">
                <LabelWithInfo name={name} info={info} />
                <div className="mt-2 ms-3">
                    {radioButtons}

                    {error &&
                    <Error id={field} error={error}/>}
                </div>
            </Col>
        </div>);
}

export default RadioVal;